"use client"

import type { ButtonHTMLAttributes, FunctionComponent, PropsWithChildren } from "react"

import { clsx } from "clsx"

import { Button } from "@jobteaser/spark/components/Button"
import { Menu } from "@jobteaser/spark/components/Icons/Menu"

import { UserAvatar } from "@/modules/dashboard/components/UserAvatar/UserAvatar"

import dropdownMenuStyles from "@/modules/headerFooterFO/Header/styles/DropdownMenuV2.module.css"

type DropdownUserButtonV2Props = PropsWithChildren<
  ButtonHTMLAttributes<HTMLButtonElement> & {
    activeHrefs: string[]
    strictActiveCheck?: boolean
    avatarUrl?: string | null
  }
>

export const DropdownUserButtonV2: FunctionComponent<DropdownUserButtonV2Props> = ({ avatarUrl, ...props }) => {
  return (
    <Button
      {...props}
      className={clsx(dropdownMenuStyles["hdr-DropdownMenu-link"])}
      variant="secondary"
      type="button"
      size="small"
    >
      <UserAvatar src={avatarUrl || ""} size={32} className={dropdownMenuStyles["hdr-DropdownMenu-avatar"]} />
      <Menu size={20} className={dropdownMenuStyles["hdr-DropdownMenu-linkMenuIcon"]} />
    </Button>
  )
}
